<div class="address-container" [formGroup]="addressForm">
  <input
    #addressInput
    matInput
    [placeholder]="placeholder"
    [matAutocomplete]="auto"
    [value]="pendingFetch ? 'Fetching full address...' : value"
    (blur)="onBlur()"
    formControlName="address"
    matAutofill
    autocomplete="off"
    />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="getPredictionLabel"
    (optionSelected)="optionSelected($event)"
    [class]="classList"
    autoActiveFirstOption
    >
    @if ($any(predictions$) | ngrxPush; as predictions) {
      @if (predictions['length']) {
        @for (address of predictions; track trackPredictions($index, address)) {
          <mat-option
            [value]="address"
            >
            <span>{{ address.label }}</span>
          </mat-option>
        }
        <div class="powered-by">
          <img
            src="/assets/images/powered_by_google.png"
            alt="Powered by Google"
            />
        </div>
      }
    }
  </mat-autocomplete>
</div>
